<template>
  <div class="place-facility-tab shared-index">
    <el-row class="table-title" type="flex" align="center">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleChangeTab">
          <el-tab-pane v-for="tab in placeTypes" :key="tab.value" :name="tab.value">
            <div slot="label">
              {{ tab.name }}
              <span v-if="activeTab === tab.value">({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="display: flex; align-items: center;">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          class="mr-2"
          @click="createPlaceFacility"
        >Thêm</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          size="small"
          class="mr-2"
          @click="handleChangeTab"
        >Làm mới</el-button>
        <import-excel-button
          size="small"
          class="mr-2"
          :disabled="callingAPI"
          :total="total"
          :columns="excelColumns"
          :type="'place-facilities'"
          :titles="placeTypes"
          :active-tab="activeTab"
          @reload="loadData"
        />
        <export-excel-button
          size="small"
          class="mr-2"
          :disabled="callingAPI || total === 0"
          :total="total"
          :columns="excelColumns"
          :type="'place-facilities'"
          :titles="placeTypes"
          :active-tab="activeTab"
        />
        <translate-button
          size="small"
          class="mr-2"
          :disabled="callingAPI"
          :total="total"
          :columns="excelColumns"
          :type="'place-facilities'"
          :titles="placeTypes"
          :active-tab="activeTab"
          @reload="loadData"
        />
      </div>
    </el-row>
    <list-place-facilities
      :loading="callingAPI"
      :data="allPlaceFacilities"
      @reload="handleReloadAfterDelete"
      @update="updatePlaceFacility"
    />
    <el-row type="flex" justify="end" class="my-4">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>
    <update-place-facility-popup
      v-if="visibleUpdate"
      :place-facility="selectedPlaceFacility"
      :visible="visibleUpdate"
      :type="activeTab"
      @close="visibleUpdate = false"
      @reload="loadData"
      @reload-constant="handleReloadConstant"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters, mapActions } from 'vuex'
import ListPlaceFacilities from './components/List.vue'
import UpdatePlaceFacilityPopup from './components/popup/Update.vue'
import ImportExcelButton from '@/components/buttons/ImportExcel.vue'
import ExportExcelButton from '@/components/buttons/ExportExcel.vue'
import TranslateButton from '@/components/buttons/Translate.vue'
import TYPE from '@/data/type'
import { getPlaceTypes, getTranslation } from '@/utils/filters'
import { getPlaceFacilities } from '@/services/place/facility'

const pTypes = getPlaceTypes(false, ['hierarchy'])

export default {
  name: 'PlaceFacilities',
  components: {
    ListPlaceFacilities,
    UpdatePlaceFacilityPopup,
    ImportExcelButton,
    ExportExcelButton,
    TranslateButton
  },
  data() {
    return {
      visibleUpdate: false,
      callingAPI: false,
      allPlaceFacilities: [],
      selectedPlaceFacility: {},
      activeTab: pTypes[0].value,
      total: 0,
      limit: 10,
      page: 1,
      searchText: '',
      placeTypes: pTypes
    }
  },
  computed: {
    ...mapGetters(['language']),
    placeType() {
      return TYPE.PLACES.find((p) => p.value === this.activeTab)
    },
    excelColumns() {
      const eColumns = (this.$route.meta.data && this.$route.meta.data.index && this.$route.meta.data.index.excelColumns) || ['id', 'name']
      return (eColumns || []).map((c) =>
        TYPE.EXCEL_COLUMNS.find((column) => c === column.key)
      )
    },
    params() {
      return {
        page: this.page,
        per_page: this.limit,
        locale: this.language,
        place_type: this.activeTab
      }
    }
  },
  watch: {
    language: 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.callingAPI = true
      this.visibleUpdate = false
      getPlaceFacilities(this.params).then((response) => {
        this.allPlaceFacilities = (response.result || []).map((r) => {
          let groupObj = r.group
          if (r.group && typeof r.group === 'object') {
            groupObj = {
              ...r.group,
              name: getTranslation(r.group, this.language) ? getTranslation(r.group, this.language).name : (r.group ? r.group.name : '')
            }
          }
          return {
            ...r,
            name: getTranslation(r, this.language) ? getTranslation(r, this.language).name : r.name,
            group: groupObj
          }
        })
        this.total = response.total || 0
        this.callingAPI = false
      }).catch(() => {
        this.callingAPI = false
      })
    },
    handleChangePage(page) {
      this.page = page
      this.loadData()
    },
    createPlaceFacility() {
      this.selectedPlaceFacility = null
      this.visibleUpdate = true
    },
    updatePlaceFacility(data) {
      this.selectedPlaceFacility = data
      this.visibleUpdate = true
    },
    handleChangeTab() {
      this.page = 1
      this.loadData()
    },
    ...mapActions('public', ['updateReloadConstant']),
    handleReloadConstant() {
      this.updateReloadConstant(dayjs().unix())
    },
    handleReloadAfterDelete() {
      if (this.allPlaceFacilities.length === 1 && this.page > 1) {
        this.page = this.page - 1
      }
      this.loadData()
      this.handleReloadConstant()
    }
  }
}
</script>

<style lang="scss" scoped>
.place-facility-tab {
  .table-title {
    &__left {
      max-width: calc(100% - 540px);
      .el-tabs {
        max-width: 100%;
      }
    }
  }
}
</style>
